export const getFileDimensions = async (file: File) => {
  let img: HTMLImageElement;
  const dataURI: any = await new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    reader.readAsDataURL(file);
  });
  img = document.createElement("img");
  document.body.appendChild(img);
  img.src = dataURI!;
  let originalWidth = img.width;
  let originalHeight = img.height;
  document.body.removeChild(img!);
  return [originalWidth, originalHeight];
};

const MAX_DIMENSION_ATTEMPTS = 5;

/**
 * getFileDimensions pode retornar [0, 0] antes da imagem terminar de
 * decodificar. Tenta algumas vezes e desiste (retornando undefined) em vez
 * de retentar indefinidamente, o que travaria o fluxo para um arquivo cujas
 * dimensões nunca resolvem (ex: imagem corrompida).
 */
export const resolveImageDimensions = async (
  file: File
): Promise<[number | undefined, number | undefined]> => {
  for (let attempt = 0; attempt < MAX_DIMENSION_ATTEMPTS; attempt++) {
    const [width, height] = await getFileDimensions(file);
    if (width && height) return [width, height];
  }
  return [undefined, undefined];
};

export const resizeFile = (
  originalWidth: number | undefined,
  originalHeight: number | undefined
) => {
  const MAX_WIDTH_HEIGHT = 500;

  if (!originalHeight || !originalWidth) return [undefined, undefined];

  if (originalWidth <= MAX_WIDTH_HEIGHT && originalHeight <= MAX_WIDTH_HEIGHT) {
    return [`${originalWidth}px`, `${originalHeight}px`];
  }

  if (originalWidth >= originalHeight) {
    const proportion = originalHeight / originalWidth;
    return [
      `${MAX_WIDTH_HEIGHT}px`,
      `${Math.floor(MAX_WIDTH_HEIGHT * proportion)}px`,
    ];
  }

  const proportion = originalWidth / originalHeight;
  return [
    `${Math.floor(MAX_WIDTH_HEIGHT * proportion)}px`,
    `${MAX_WIDTH_HEIGHT}px`,
  ];
};
